import { GoogleAuthProvider } from "firebase/auth";

// Force Google's account chooser on every sign-in. `select_account` alone
// can be ignored when the browser reuses a cached Google session; adding
// `consent` makes Google re-prompt instead of silently picking an account.
export function createGoogleAuthProvider() {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account consent" });
  return provider;
}
